module.exports = __webpack_public_path__ + "static/media/box6.04a1a23e.jpeg";